import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import Spinner from "../../../../components/icons/Spinner";
import { GET_WEBSITE } from "../../../../utils/api/website";

const WebsiteRoot = () => {
  const { websiteId } = useParams();

  const { loading, error, data } = useQuery(GET_WEBSITE, {
    variables: { websiteId },
  });

  if (loading) {
    return <Spinner />;
  }

  return (
    <Outlet context={{ website: data.website }} />
  )
};

export default WebsiteRoot;
